let store = null;
export const getStore = () => store;
export const setStore = (newStore) => {
  store = newStore;
};
